export default "__VITE_ASSET__DXya3iwm__"